var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "dialog-container",
          attrs: {
            visible: _vm.addDialog,
            title: _vm.title,
            width: "60%",
            "modal-append-to-body": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.addDialog = $event
            },
            "update:title": function ($event) {
              _vm.title = $event
            },
            close: _vm.handleCancel,
            open: _vm.beforeOpenDialog,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "addFrom",
              attrs: {
                model: _vm.addFrom,
                rules: _vm.addRules,
                "label-width": "100px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "权益编号", prop: "rightsCode" } },
                [
                  _c("el-input", {
                    attrs: {
                      disabled: _vm.title === "编辑会员权益",
                      type: "textarea",
                      autosize: { minRows: 2, maxRows: 10 },
                      maxlength: "99",
                      "show-word-limit": "",
                      width: "40%",
                    },
                    model: {
                      value: _vm.addFrom.rightsCode,
                      callback: function ($$v) {
                        _vm.$set(_vm.addFrom, "rightsCode", $$v)
                      },
                      expression: "addFrom.rightsCode",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "权益名称", prop: "rightsName" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      autosize: { minRows: 2, maxRows: 10 },
                      maxlength: "99",
                      "show-word-limit": "",
                    },
                    model: {
                      value: _vm.addFrom.rightsName,
                      callback: function ($$v) {
                        _vm.$set(_vm.addFrom, "rightsName", $$v)
                      },
                      expression: "addFrom.rightsName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "描述文案", prop: "description" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      autosize: { minRows: 2, maxRows: 10 },
                      maxlength: "999",
                      "show-word-limit": "",
                    },
                    model: {
                      value: _vm.addFrom.description,
                      callback: function ($$v) {
                        _vm.$set(_vm.addFrom, "description", $$v)
                      },
                      expression: "addFrom.description",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "客户端类型", prop: "clientTypes" } },
                [
                  _c(
                    "el-checkbox-group",
                    {
                      model: {
                        value: _vm.addFrom.clientTypes,
                        callback: function ($$v) {
                          _vm.$set(_vm.addFrom, "clientTypes", $$v)
                        },
                        expression: "addFrom.clientTypes",
                      },
                    },
                    _vm._l(_vm.clientTypes, function (item) {
                      return _c(
                        "el-checkbox",
                        { key: item.dictKey, attrs: { label: item.dictKey } },
                        [_vm._v(_vm._s(item.dictValue))]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "限制参数", prop: "limitParams" } },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-bottom": "10px" },
                      attrs: {
                        type: "primary",
                        size: "small",
                        disabled:
                          _vm.selectedParams.length >= _vm.limitParams.length,
                      },
                      on: { click: _vm.addLimitParams },
                    },
                    [_vm._v("添加限制参数")]
                  ),
                  _vm._l(_vm.selectedParams, function (item, index) {
                    return _c(
                      "div",
                      {
                        key: item.dictKey,
                        staticStyle: {
                          display: "flex",
                          "margin-bottom": "10px",
                        },
                      },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: {
                              width: "50%",
                              "margin-right": "10px",
                            },
                            attrs: {
                              value: item.dictKey,
                              placeholder: item.dictValue,
                            },
                            on: {
                              input: function ($event) {
                                return _vm.handleLimitParamsChange(
                                  $event,
                                  item,
                                  index
                                )
                              },
                            },
                          },
                          _vm._l(_vm.limitParams, function (option) {
                            return _c("el-option", {
                              key: option.dictKey,
                              attrs: {
                                label: option.dictValue,
                                value: option.dictKey,
                                disabled: _vm.isLimitParamSelected(
                                  option.dictKey,
                                  item
                                ),
                              },
                            })
                          }),
                          1
                        ),
                        _c(
                          "el-button",
                          {
                            staticStyle: { color: "#ff0000" },
                            attrs: {
                              icon: "el-icon-delete",
                              type: "text",
                              size: "small",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.handleLimitParamsDel(item, index)
                              },
                            },
                          },
                          [_vm._v("删除")]
                        ),
                      ],
                      1
                    )
                  }),
                ],
                2
              ),
              _c(
                "el-form-item",
                { attrs: { label: "权益状态", prop: "state" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.addFrom.state,
                        callback: function ($$v) {
                          _vm.$set(_vm.addFrom, "state", $$v)
                        },
                        expression: "addFrom.state",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [_vm._v("生效")]),
                      _c("el-radio", { attrs: { label: 0 } }, [_vm._v("失效")]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "备注", prop: "remark" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      width: "40%",
                      autosize: { minRows: 2, maxRows: 10000 },
                      maxlength: "9999",
                      "show-word-limit": "",
                    },
                    model: {
                      value: _vm.addFrom.remark,
                      callback: function ($$v) {
                        _vm.$set(_vm.addFrom, "remark", $$v)
                      },
                      expression: "addFrom.remark",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.handleCancel } }, [
                _vm._v("取 消"),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.handleConfirm },
                },
                [_vm._v("保 存")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }